exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, "/* container */\n.top-products {\n  margin-top: 20px; }\n\n@media only screen and (max-width: 768px) {\n  .top-products {\n    max-width: calc(100vw - 10px);\n    margin-left: 5px;\n    margin-right: 5px; }\n    .top-products .custom-table tr td:last-child {\n      padding-right: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/topProducts/TopProducts.scss
// module id = 1633
// module chunks = 0